import React, { useState } from "react";
import { Input, Label } from 'reactstrap';
import Flatpickr from "react-flatpickr";

const DatePicker2 = ({ label, mode, value, placeholder, setValues, name, enableTime, maxDate }) => {
    
    const handleDateChange = (selectedDates, dateStr, instance) => {
        if (mode !== 'range' || selectedDates.length === 2 || selectedDates.length === 0) {
            setValues(prev => ({ ...prev, [name]: selectedDates }));
        }
    };
    
    const flatpickrValue = Array.isArray(value) ? value : [];

    return (
        <>
            <div className="mb-3">
                <Label className="form-label">{label}</Label>
                <Flatpickr
                    className="form-control form-control-sm"
                    value={flatpickrValue} 
                    options={{
                        enableTime: enableTime,
                        dateFormat: enableTime ? "Y-m-d H:i" : "Y-m-d",
                       defaultDate: [new Date()],
                        mode: mode,
                        maxDate: maxDate
                    }}
                    onChange={handleDateChange} 
                    placeholder={placeholder}
                />
            </div>
        </>
    );
};

export default DatePicker2;